/**
 动态的接口
 */
import Vue from "vue";

/**
 * 获取所有/个人动态
 */
export function getMoment(data){
    return  Vue.$axios({
        url: '/api/user/moment/getMoment',
        method: 'post',
        data
    })
}

/**
 发布动态
 **/
export function publishTrend(data){
    return  Vue.$axios({
        url: '/api/user/moment/setMoment',
        method: 'post',
        data
    })
}
/**
 删除动态
 **/
export function delMoment(data){
    return  Vue.$axios({
        url: '/api/user/moment/delMoment',
        method: 'post',
        data
    })
}
/**
 根据id获取用户信息
 **/
export function getUserinfoById(data){
    return  Vue.$axios({
        url: '/api/user/moment/getMomentUserInfo',
        method: 'post',
        data
    })
}

/**
 根据动态ID获取动态详情
 **/
export function getContent(data){
    return  Vue.$axios({
        url: '/api/user/moment/getContent',
        method: 'post',
        data
    })
}

/**
 *点赞/取消点赞
 */
export function likeOrNotLike(data){
    return  Vue.$axios({
        url: '/api/user/moment_like/like',
        method: 'post',
        data
    })
}


/**
 获取评论列表
 **/
export function getCommentById(data){
    return  Vue.$axios({
        url: '/api/user/moment_comments/getComments',
        method: 'post',
        data
    })
}

/**
 添加评论
 **/
export function addComment(data){
    return  Vue.$axios({
        url: '/api/user/moment_comments/setComments',
        method: 'post',
        data
    })
}
/**
 关注
 **/
export function followUser(data){
    return  Vue.$axios({
        url: '/api/firm/main/follow',
        method: 'post',
        data
    })
}
/**
 取关
 **/
export function unfollowUser(data){
    return  Vue.$axios({
        url: '/api/firm/main/unfollow',
        method: 'post',
        data
    })
}
/**
 屏蔽
 **/
export function banUser(data){
    return  Vue.$axios({
        url: '/api/user/user_ban/add',
        method: 'post',
        data
    })
}
/**
 获取举报类型
 **/
export function getJuBaoType(data){
    return  Vue.$axios({
        url: '/api/user/jubao/subjects',
        method: 'post',
        data
    })
}
/**
 举报
 **/
export function juBao(data){
    return  Vue.$axios({
        url: '/api/user/jubao/submit',
        method: 'post',
        data
    })
}
